<template>
<transition name="slide-fade" mode="out-in"> 
  <div id="service" v-wechat-title="$route.meta.title">
    <van-nav-bar title="麻丘镇一键举报" fixed left-arrow @click-left="onClickLeft" />
    <div class="main">
      <div class="top-img">
        <img src="@/assets/type1.png" v-if="type == 1" />
        <img src="@/assets/type2.png" v-if="type == 2" />
        <img src="@/assets/type3.png" v-if="type == 3" />
        <img src="@/assets/type4.png" v-if="type == 4" />
        <img src="@/assets/type5.png" v-if="type == 5" />
      </div>
      <div class="main-form">
        <div class="form-item">
          <div class="item-tit">举报人信息 （注：标有*的必须填写）</div>
          <div style="padding:0 0.5rem">
            <van-field v-model="name" clearable required label="姓名" placeholder="请填写姓名" />
            <van-field v-model="identity" clearable required label="身份证号" placeholder="请填写身份证号" />
            <van-field v-model="phone" clearable required label="联系电话" placeholder="请填写联系电话" />
            <van-field
              readonly
              v-model="politics"
              label="政治面貌"
              right-icon="arrow-down"
              placeholder="请选择政治面貌"
              @click="toPolitics()"
            />
            <van-field v-model="address" clearable required label="现居住地址" placeholder="请填写现居住地址" />
            <van-field
              readonly
              v-model="grade"
              required
              label="级别"
              right-icon="arrow-down"
              placeholder="请选择级别"
              @click="toGrade()"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="item-tit">被举报人（单位）（注：标有*的必须填写）</div>
          <div style="padding:0 0.5rem">
            <van-field v-model="nameBe" clearable required label="被举报人" placeholder="请填写被举报人姓名" />
            <van-field v-model="unitBe" clearable required label="单位" placeholder="请填写被举报人单位" />
            <van-field v-model="positionBe" clearable required label="职位" placeholder="请填写被举报人单位" />
            <van-field
              readonly
              v-model="addressBe"
              label="所在地区"
              right-icon="arrow-down"
              placeholder="请选择被举报人所在地区"
              @click="toAddressBe()"
            />
            <van-field
              readonly
              v-model="gradeBe"
              required
              label="级别"
              right-icon="arrow-down"
              placeholder="请选择被举报人级别"
              @click="toGradeBe()"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="item-tit">举报正文（注：标有*的必须填写）</div>
          <div style="padding:0 0.5rem">
            <van-field
              v-model="title"
              clearable
              required
              maxlength="25"
              label="标题"
              placeholder="最多25个字"
            />
            <van-field
              v-model="question"
              rows="6"
              autosize
              clearable
              required
              label="主要问题"
              type="textarea"
              maxlength="300"
              placeholder="请输入主要问题"
              show-word-limit
            />
          </div>
        </div>
        <div class="form-item">
          <div class="item-tit">上传图片（注：最多可上传5张图片）</div>
          <div style="padding:1rem">
            <van-uploader v-model="fileList" :max-count="5" :after-read="afterRead" @delete="deleteImg" />
          </div>
        </div>
        <div class="comfirm" @click="toComfirm()">提交</div>
      </div>
    </div>
    <van-popup v-model="showPolit" position="bottom">
      <van-picker
        title="政治面貌"
        show-toolbar
        :columns="politicsPick"
        @confirm="onConfirm1"
        @cancel="onCancel1"
      />
    </van-popup>
    <van-popup v-model="showGrade" position="bottom">
      <van-picker
        title="级别"
        show-toolbar
        :columns="gradePick"
        @confirm="onConfirm2"
        @cancel="onCancel2"
      />
    </van-popup>
    <van-popup v-model="showAddressBe" position="bottom">
      <van-picker
        title="被举报人所在地区"
        show-toolbar
        :columns="addressPickBe"
        @confirm="onConfirm3"
        @cancel="onCancel3"
      />
    </van-popup>
    <van-popup v-model="showGradeBe" position="bottom">
      <van-picker
        title="被举报人级别"
        show-toolbar
        :columns="gradePickBe"
        @confirm="onConfirm4"
        @cancel="onCancel4"
      />
    </van-popup>
  </div>
</transition>
</template>
<script>
import { NavBar, Field, Icon, Picker, Popup, Toast, Uploader } from "vant";
import { village, uploadImages, report } from "@/api/apiData";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Uploader.name]: Uploader
  },
  data() {
    return {
      type: 0,
      name: "", //姓名
      identity: "", //身份证号
      phone: "", //联系电话
      politics: "", //政治面貌
      politics_index: 0,
      address: "", //现居住地址
      grade: "", //级别
      grade_index: "", //级别
      showPolit: false,
      showGrade: false,
      politicsPick: [
        "中国共产党党员",
        "中共预备党员",
        "共青团员",
        "民主党派人士",
        "无党派民主人士",
        "群众"
      ],
      gradePick: [
        "正省部局",
        "副省部级",
        "正厅局级",
        "副厅局级",
        "正县处级",
        "副县处级",
        "正乡科级",
        "副乡科级",
        "一般干部",
        "军队",
        "金融机构",
        "一般企业",
        "事业",
        "农村",
        "其他"
      ],
      addressPickBe: [], //被举报人所在地区
      gradePickBe: [
        "正乡科级",
        "副乡科级",
        "一般干部",
        "军队",
        "金融机构",
        "一般企业",
        "事业",
        "农村",
        "其他"
      ], //被举报人级别
      nameBe: "", //被举报人
      unitBe: "", //被举报人单位
      positionBe: "", //被举报人职位
      addressBe: "", //被举报人所在地区
      addressBe_index: 0,
      gradeBe: "", //被举报人级别
      gradeBe_index: 0,
      showAddressBe: false,
      showGradeBe: false,
      title: "", //标题
      question: "", //主要问题
      fileList: [],
      imagesArr: [],
      images: "",
      catid: 1
    };
  },
  mounted() {
    var type = this.$route.query.type;
    this.catid = type;
    this.type = type;
    this.getVillage();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    // 图片上传
    afterRead(file) {
      var fileNew = "";
      // 大于1MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 1000000) {
        // let cal = 1024*1024/file.file.size; //计算比例，也可以自己定义比例 0.5等等
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          //最大高度
          const maxHeight = 500;
          //最大宽度
          const maxWidth = 500;
          // 指定canvas画布大小，该大小为最后生成图片的大小
          const originHeight = img.height;
          const originWidth = img.width;
          let compressedWidth = img.height;
          let compressedHeight = img.width;
          if (originWidth > maxWidth && originHeight > maxHeight) {
            // 更宽更高，
            if (originHeight / originWidth > maxHeight / maxWidth) {
              // 更加严重的高窄型，确定最大高，压缩宽度
              compressedHeight = maxHeight;
              compressedWidth = maxHeight * (originWidth / originHeight);
            } else {
              //更加严重的矮宽型, 确定最大宽，压缩高度
              compressedWidth = maxWidth;
              compressedHeight = maxWidth * (originHeight / originWidth);
            }
          } else if (originWidth > maxWidth && originHeight <= maxHeight) {
            // 更宽，但比较矮，以maxWidth作为基准
            compressedWidth = maxWidth;
            compressedHeight = maxWidth * (originHeight / originWidth);
          } else if (originWidth <= maxWidth && originHeight > maxHeight) {
            // 比较窄，但很高，取maxHight为基准
            compressedHeight = maxHeight;
            compressedWidth = maxHeight * (originWidth / originHeight);
          } else {
            // 符合宽高限制，不做压缩
          }
          canvas.height = compressedHeight;
          canvas.width = compressedWidth;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, compressedWidth, compressedHeight);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);
          // 最后将base64编码的图片保存到数组中，留待上传。
          var parm = {
            file: file.content
          };
          uploadImages(parm).then(res => {
            this.imagesArr.push(res.data[0]);
          });
        };
      } else {
        var parm = {
          file: file.content
        };
        uploadImages(parm).then(res => {
          this.imagesArr.push(res.data[0]);
        });
      }
    },
    deleteImg(file, name) {
      var index = name.index;
      this.imagesArr.splice(index, 1);
    },
    // 举报人信息
    toPolitics() {
      this.showPolit = true;
    },
    onConfirm1(value, index) {
      //   Toast(`当前值：${value}, 当前索引：${index}`);
      this.politics = value;
      this.politics_index = index;
      this.showPolit = false;
    },
    onCancel1() {
      //   Toast('取消');
      this.showPolit = false;
    },
    // 举报人级别
    toGrade() {
      this.showGrade = true;
    },
    onConfirm2(value, index) {
      //   Toast(`当前值：${value}, 当前索引：${index}`);
      this.grade = value;
      this.grade_index = index;
      this.showGrade = false;
    },
    onCancel2() {
      //   Toast('取消');
      this.showGrade = false;
    },
    // 被举报人地址
    toAddressBe() {
      this.showAddressBe = true;
    },
    onConfirm3(value, index) {
      //   Toast(`当前值：${value}, 当前索引：${index}`);
      this.addressBe = value.text;
      this.addressBe_index = value.keyId;
      this.showAddressBe = false;
    },
    onCancel3() {
      //   Toast('取消');
      this.showAddressBe = false;
    },
    // 被举报人级别
    toGradeBe() {
      this.showGradeBe = true;
    },
    onConfirm4(value, index) {
      //   Toast(`当前值：${value}, 当前索引：${index}`);
      this.gradeBe = value;
      this.gradeBe_index = index;
      this.showGradeBe = false;
    },
    onCancel4() {
      //   Toast('取消');
      this.showGradeBe = false;
    },
    // 获取地区
    getVillage() {
      village().then(res => {
        this.addressPickBe = res.map(item => {
          return { text: item.name, keyId: item.id };
        });
      });
    },
    // 提交
    toComfirm() {
      this.images = this.imagesArr.toString();
      var parm = {
        catid: this.catid,
        name: this.name,
        card: this.identity,
        phone: this.phone,
        political: this.politics_index,
        addr: this.address,
        level: this.grade_index,
        reported_person: this.nameBe,
        reported_unit: this.unitBe,
        reported_position: this.positionBe,
        reported_vid: this.addressBe_index,
        reported_level: this.gradeBe_index,
        title: this.title,
        problem: this.question,
        images: this.images
      };
      // 校验身份证：
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (reg.test(this.identity) === false) {
        Toast("身份证输入不合法");
      }else if (!/^1[34578]\d{9}$/.test(this.phone)) {
        Toast("请填写正确电话");
      }else{
        report(parm).then(res => {
        Toast(res.msg);
        if (res.code == 1) {
          this.$router.go(-1);
        }
      });
      }
    }
  }
};
</script>
<style scoped>
#service {
  padding-top: 46px;
  height: 100%;
  background: #ebebeb;
}
.top-img img {
  width: 100%;
}
.form-item {
  margin: 1.5rem;
  text-align: left;
  background: white;
  border-radius: 5px 5px 0px 0;
}
.item-tit {
  background: #ff1106;
  color: white;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border-radius: 5px 5px 0px 0;
}
.comfirm {
  background: #ff1106;
  color: white;
  padding: 0.5rem 1rem;
  margin: 3rem 1.5rem;
  border-radius: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/page/form.vue